// @flow
export const If = ({ test, children }) => {
  return test ? children : null;
};
